import { useSession } from 'contexts/session';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function useCheckAuth() {
  const navigate = useNavigate();
  const [session] = useSession();

  useEffect(() => {
    if (!session?.user) {
      navigate('/');
    }
  }, [navigate, session?.user]);
}
